import {
  AppBar,
  Button,
  IconButton,
  ListItemIcon,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { Delete } from "@mui/icons-material";
import { getData } from "../../../../services/library";
import CloseIcon from "@mui/icons-material/Close";
import EntregasConRemitoCliente from "./remitos/EntregasConRemitoCliente";
import AgregarClienteAsociado from "./agregarClientes/AgregarClienteAsociado";

function ClientesAsociados() {
  const [clientesAsociados, setClientesAsociados] = useState([]);
  const [dataRow, setDataRow] = useState();
  const [entregasConRemito, setEntregasConRemito] = useState(false)
  const [alta, setAlta] = useState(false);
  
  const location = useLocation();
  let navigate = useNavigate();
  
  const [facturador, setFacturador] = useState(location.state)
  const onBack = () => navigate(-1);

  const obtenerClientes = () => {
    getData("/envasado_clientes/clientesasociados/" + location.state.id, setClientesAsociados);
  };

  useEffect(() => {
    obtenerClientes();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 20,
      },
      {
        accessorKey: "razon_social", //access nested data with dot notation
        header: "Razón Social",
        size: 230,
      },
      {
        accessorKey: "direccion_fiscal", //access nested data with dot notation
        header: "Dirección Fiscal",
        size: 180,
      },
      {
        accessorKey: "nombre_sucursal", //access nested data with dot notation
        header: "Sucursal",
        size: 180,
      },
    ],
    [],
  );
  
  const handleCloseEntregas = () => {
    setEntregasConRemito(false);
  };
  
  const handleClickNuevo = () => {
    setAlta(true);
  };

  const handleCloseAlta = () => {
    setAlta(false);
    // setTabla(true);
    obtenerClientes();
  };

  
  return (
      <div>
        <AppBar
          sx={{ position: "relative" }}
          style={{ backgroundColor: "#0979b0" }}
        >
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onBack}>
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Clientes Asociados a {location.state.razon_social}
            </Typography>
          </Toolbar>
        </AppBar>

        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={clientesAsociados ?? []}
          layoutMode="grid"
          initialState={{
            density: "compact",
            showGlobalFilter: true,
            pagination: { pageIndex: 0, pageSize: 10 },
          }}
          enableColumnActions={false}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableRowActions={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn="last"
          enableExpandAll={false}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={{
            align: "left",
            sx: {
              fontSize: 16,
              color: "white",
              fontWeight: "normal",
              backgroundColor: "#2471A3",
              borderColor: "black",
            },
          }}
          muiSearchTextFieldProps={{
            placeholder: "Buscar..",
            sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
            variant: "outlined",
            color: "success",
            size: "small",
          }}
          enableDensityToggle={false}
          enableColumnResizing={true}
          muiTableBodyCellProps={{
            align: "left",
            sx: { color: "black" },
          }}
          renderTopToolbarCustomActions={() => (
            <>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddBoxTwoToneIcon color="asd" />}
                onClick={handleClickNuevo}
              >
                Agregar Clientes
              </Button>
            </>
          )}
          renderRowActions={({ row }) => (
            <Tooltip arrow placement="right" title="Ver Entregas">
              <IconButton
                onClick={() => {
                  // closeMenu();
                  setDataRow(row.original);
                  setEntregasConRemito(true);
                }}
                color="primary"
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          )}
        />
        {entregasConRemito ? (
          <EntregasConRemitoCliente
            entregasConRemito={entregasConRemito}
            datosRow={dataRow}
            onClose={() => handleCloseEntregas(false)}
          />
        ) : null}
        {alta ? (
          <AgregarClienteAsociado
            alta={alta}
            onClose={() => handleCloseAlta(false)}
            datosRow={facturador}
            clientesAsociados={clientesAsociados}
          />
        ) : null}
      </div>
  );
}

export default ClientesAsociados;
